/* eslint-disable @typescript-eslint/no-explicit-any */
import newColorAxiosInstance from "@/common-components-src/api/new-color-axiosInstance";
import { GetCartRequest, CartData, TypeDetailInfo, SystemInfo } from "./cart.interface";

/*
 * https://joyspace.jd.com/pages/BtxZlGfcF01xyoDFMsEJ
 * @interface Data
 */

interface Data {
  resultInfo: CartData;
}
interface TypeData {
  resultInfo: TypeDetailInfo;
  systemInfo: SystemInfo;
}

// 查询购物车详情的 API 方法
export const fetchCartDetail = (requestData: GetCartRequest): Promise<CartData> => {
  return newColorAxiosInstance
    .get<Data>(`trade_cart_get`, { params: { ...requestData } })
    .then((response: any) => response?.data?.data)
    .catch((error: any) => error);
};

// 全选/单选/数量加减
export const selectAll = (requestData: GetCartRequest): Promise<CartData> => {
  return newColorAxiosInstance
    .post<Data>(`trade_cart_modifyItem`, undefined, {
      params: { ...requestData },
    })
    .then((response: any) => response?.data?.data)
    .catch((error: any) => error);
};

// 选择其他商品类型 API 方法
export const selectOtherProType = (requestData: GetCartRequest): Promise<TypeData> => {
  return newColorAxiosInstance
    .get<TypeData>(`trade_item_getLite`, {
      params: { ...requestData },
    })
    .then((response: any) => response?.data?.data)
    .catch((error: any) => error);
};

// 加入购物车 API 方法
export const addCart = (requestData: GetCartRequest): Promise<CartData> => {
  return newColorAxiosInstance
    .get<CartData>(`trade_cart_addItem`, {
      params: { ...requestData },
    })
    .then((response: any) => response?.data)
    .catch((error: any) => error);
};

// 拼购推荐列表 https://joyspace.jd.com/pages/weO4RiBTmBfh9Uix1Q11
export const recommendList = (requestData: any): Promise<any> => {
  return newColorAxiosInstance
    .post<any>(`guide_recommendation_get`, undefined, {
      params: { ...requestData },
    })
    .then((response: any) => response?.data?.data)
    .catch((error: any) => error);
};
